<template>
  <div>
    <div :class="[cardValidation.showError ? 'card-input-invalid' : 'card-input']" id="card-element"></div>
    <label class="error-message" v-if="cardValidation.showError">{{ cardValidation.errorMessage }}</label>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stripe: {},
      card: {},
      isCardComplete: false,
      isCardEmpty: true,
      cardValidation: {
        showError: false,
        errorMessage: 'Invalid card details!',
        isComplete: false,
        isEmpty: true,
      },
    };
  },
  mounted: function () {
    let stripeScript = document.createElement('script');
    stripeScript.setAttribute('src', 'https://js.stripe.com/v3/');
    document.head.appendChild(stripeScript);

    let self = this;
    stripeScript.onload = function () {
      self.initialStripe();
      self.createIntent();
    };
  },
  props: {
    clientSecret: {
      type: String,
      required: true,
    },
    publishableToken: {
      type: String,
      required: true,
    },
    triggerSetupPayment: {
      type: Boolean,
      required: true,
    },
    cardHolderName: {
      type: String,
    },
    events: {
      type: Object,
      required: true,
    },
  },
  methods: {
    initialStripe() {
      this.stripe = window.Stripe(this.publishableToken);
    },
    createIntent() {
      var elements = this.stripe.elements();
      var style = {
        base: {
          color: '#32325d',
          fontSmoothing: 'antialiased',
          '::placeholder': {
            color: '#32325d',
          },
          fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
        },
        invalid: {
          fontFamily: 'Arial, sans-serif',
          color: '#fa755a',
          iconColor: '#fa755a',
        },
        empty: {
          '::placeholder': {
            color: '#bfbfbfff',
            fontWeight: '400',
          },
        },
      };

      this.card = elements.create('card', { hidePostalCode: true, style: style });
      this.card.mount('#card-element');

      let self = this;
      this.card.on('change', function (event) {
        self.cardValidation.isComplete = event.complete;
        self.cardValidation.isEmpty = event.empty;
      });
    },
    setupPayment() {
      let self = this;
      self.$emit(self.events.validationStarted);
      this.stripe
        .confirmCardSetup(self.clientSecret, {
          payment_method: {
            card: self.card,
            billing_details: {
              name: self.cardHolderName,
            },
          },
        })
        .then(function (result) {
          if (result.error) {
            self.cardValidation.showError = true;
            self.cardValidation.errorMessage = result.error.message;
            self.$emit(self.events.validationEnded);
          } else {
            self.cardValidation.showError = false;
            result.setupIntent.cardholderName = self.cardHolderName;
            self.$emit(self.events.paymentAdded, result.setupIntent);
          }
        });
    },
  },
  watch: {
    triggerSetupPayment(val) {
      if (val) {
        this.setupPayment();
      }
    },
  },
};
</script>

<style lang="scss">
.card-input {
  padding: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.card-input-invalid {
  padding: 10px;
  border: 1px solid #f5222d;
  border-radius: 4px;
}
</style>
